import * as React from "react";
import { forwardRef } from "react";
const SvgPriorityLow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8.58, viewBox: "0 0 8 8.58", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 10v5.72h1.5V10zm0 7.15v1.43h1.5v-1.43z", "data-name": "icon/priority/normal", transform: "translate(-11.751 -10)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgPriorityLow);
export { ForwardRef as ReactComponent };
